
import ShapeEven from '@/assets/svg/icons/shape-even.svg';
import Vue from 'vue';

export default Vue.extend({
  props: {
    text: {
      type: String,
    },
    image1: {
      type: Object,
    },
    image2: {
      type: Object,
    },
    linksDescription: {
      type: String,
    },
    links: {
      type: Array as () => Array<any>,
    },
  },
  components: { ShapeEven },
  mounted() {},
});
